module.exports = {
  footerText: 'Finekra © 2025',
}
